import { render, staticRenderFns } from "./treatment-option-selector.vue?vue&type=template&id=3c948d06&"
import script from "./treatment-option-selector.vue?vue&type=script&lang=js&"
export * from "./treatment-option-selector.vue?vue&type=script&lang=js&"
import style0 from "./treatment-option-selector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports